import React from "react";

const PHONE = "5583996477374";
const MESSAGE = "Olá Guia de Jampa, gostaria de mais informações sobre os planos e como usar a melhor IA de João Pessoa!";

export default function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 pl-4 pr-5 py-3 font-semibold hover:scale-105 active:scale-95 transition-transform"
    >
      <svg viewBox="0 0 32 32" className="w-6 h-6 fill-current" aria-hidden="true">
        <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.117.553 4.184 1.605 6.006L4 29l8.166-1.57a11.94 11.94 0 0 0 3.837.63h.003C22.62 28.06 28 22.677 28 16.057 28 8.437 22.62 3 16.003 3zm0 21.86h-.002a9.9 9.9 0 0 1-3.463-.62l-.248-.093-4.845.932.93-4.72-.162-.257a9.86 9.86 0 0 1-1.53-5.27c0-5.47 4.45-9.92 9.92-9.92 2.65 0 5.14 1.033 7.01 2.907a9.86 9.86 0 0 1 2.9 7.02c0 5.47-4.45 9.92-9.92 9.92zm5.44-7.42c-.297-.15-1.76-.868-2.032-.967-.272-.1-.47-.15-.67.15-.198.297-.767.967-.94 1.166-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.76-1.653-2.057-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.15-.174.198-.298.298-.497.099-.198.05-.372-.025-.52-.075-.15-.67-1.612-.918-2.207-.242-.58-.487-.5-.67-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.478 0 1.46 1.065 2.872 1.213 3.07.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.76-.72 2.007-1.414.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347z" />
      </svg>
      <span className="hidden sm:inline text-sm">Fale conosco</span>
    </a>
  );
}
